export default "__VITE_ASSET__BE33yXhK__"